import { Component, OnDestroy, OnInit } from "@angular/core";
// ✅ CHANGED: Removed IServerSideGetRowsParams → IDatasource + IGetRowsParams
import { ColDef, IDatasource, IGetRowsParams } from "ag-grid-community";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription, forkJoin } from "rxjs";
import { ServerRequest } from "src/app/_models/global.data.model";
import { ChecklistService } from "src/app/_services/checklist.service";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { ProjectService } from "src/app/_services/project.service";
import { SiteService } from "src/app/_services/site.service";
import { TasksService } from "src/app/_services/tasks.service";
import { TeamService } from "src/app/_services/team.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { ButtonRendererComponent } from "src/app/renderer/button-renderer.component";
import { TableHeaderToolTipComponent } from "src/app/shared/table-header-tool-tip/table-header-tool-tip.component";
import { AuthenticationService } from "src/app/auth/authentication.service";
import { GlobalJobordersService } from "src/app/_services/global-joborders.service";

@Component({
  selector: "app-add-jo-task-template",
  templateUrl: "./add-jo-task-template.component.html",
  styleUrls: ["./add-jo-task-template.component.scss"],
  standalone: false,
})
export class AddJoTaskTemplateComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  filter: any = { teamId: null, siteId: null, projectId: null };

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any;
  defaultColDef: any;
  frameworkComponents: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  // ✅ CHANGED: typed as any (GridOptions import removed)
  gridOptions: any;
  overlayNoRowsTemplate: any;
  productsFamilies: any;
  productsType: any;
  searchValue: any;
  currentRecordNumber: any;
  totalRecord: any;

  refresherPickList!: Subscription;
  DataDetails: any[] = [];
  notaskTemplate: boolean = false;
  notaskTemplateIcon: boolean = false;
  taskTemplateData: any;
  teams: any;
  allProjects: any[] = [];
  allSites: any[] = [];
  tmplJobOrderId: any;
  taskTriggers: any = { id: null, tmplTasks: [] };
  selectAllChecked: boolean = false;
  formData: any = { tasks: [] };
  rowSelection: any;
  orderGridTotalLength: any;
  submitTouched: boolean = true;
  data: any;
  translate: any;
  loadTable: number = 0;
  isNewJOTemplate: boolean = false;
  addonFeature: any;
  packageCode: string = localStorage.getItem("packageCode") || "";

  constructor(
    private spinner: NgxSpinnerService,
    private tasksService: TasksService,
    private errorUtil: ErrorUtil,
    private teamService: TeamService,
    private projectService: ProjectService,
    private sitesService: SiteService,
    public modalRef: BsModalRef,
    private checklistService: ChecklistService,
    private auth: AuthenticationService,
    private globalJobordersService: GlobalJobordersService,
    private languageTranslateService: LanguageTranslateService,
    private bsModalServc: BsModalService,
  ) {
    super();

    this.rowSelection = "multiple";
    this.frameworkComponents = { buttonRenderer: ButtonRendererComponent };

    this.gridOptions = {
      cacheBlockSize: 20,
      rowModelType: "infinite",
      rowSelection: "multiple",
      suppressRowClickSelection: false,
      paginationPageSizeSelector: false,
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params: any) => { params.api.sizeColumnsToFit(); },
      tooltipShowDelay: 100,
     
    };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };
  }

  ngOnInit() {
    this.getLanguageData();

    if (this.data.comingFrom == undefined) {
      this.taskTriggers.id = this.data.tmplJobOrderId;
    } else {
      this.taskTriggers.tmplChecklistAns = { id: this.data.selectedAnswerId };
    }

    this.data.skipTaskListIds =
      this.data.skipTaskListIds && this.data.skipTaskListIds != ""
        ? this.data.skipTaskListIds
        : null;

    if (this.data.skipTaskListIds) {
      this.data.skipTaskListIds = this.data.skipTaskListIds.split(",");
      this.data.skipTaskListIds = this.data.skipTaskListIds.map((i: any) => Number(i));
    }

    this.addonFeature = this.auth.getAddonFeatureLists();

    var tenantPackagesJO2 = this.auth.getPackageCodeWithList("JO2");
    if (this.packageCode == "Old") {
      this.isNewJOTemplate = this.addonFeature.addonJO2 == "JO2" ? true : false;
    } else {
      if (this.auth.getAddonPackageListsToHide("JO2")) {
        this.isNewJOTemplate =
          tenantPackagesJO2.addonPackageList == "JO2" || this.addonFeature.addonJO2 == "JO2"
            ? true
            : false;
      } else {
        this.isNewJOTemplate = false;
      }
    }
  }

  ngOnDestroy(): void { super.ngOnDestroy(); }

  /********************************** Filter List **************************/
  getFilterList() {
    const sources = [
      this.sitesService.getSitePicklist(null),
      this.teamService.getAllTeamsPickList(),
      this.projectService.getAllProjectPickList(null),
    ];

    forkJoin(sources).subscribe(([sitesResponce, teamsResponce, projectsResponce]) => {
      this.allSites = sitesResponce;
      this.teams = teamsResponce;
      this.allProjects = projectsResponce;
    });
  }

  onPageSizeChanged() { this.gridApi.paginationSetPageSize(Number(this.pageSize)); }
  filterResults() { this.gridApi.setGridOption("quickFilterText", this.searchValue); }

  /********************************** On Grid Ready **************************/
  onGridReady(params: any) {
    this.gridParams = params;
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    // ✅ CHANGED: IDatasource with IGetRowsParams
    const dataSource: IDatasource = {
      getRows: (params: IGetRowsParams) => {
        this.getServerSideData(params);
      },
    };

    this.gridApi.sizeColumnsToFit();
    this.gridApi.setGridOption("datasource", dataSource);
  }

  /********************************** Get Server Side Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

    this.tasksService
      .getAllTaskTemplates_(
        this.searchValue,
        serverRequest,
        this.filter.siteId,
        this.filter.projectId,
        this.filter.teamId,
        null,
        this.data.skipTaskListIds,
        {},
        "ACTIVE"
      )
      .subscribe(
        (data: any) => {
          this.taskTemplateData = data.body.data;
          this.totalRecord = data.body.total;
          this.orderGridTotalLength = data.body.total;
          this.setGridData(agGridGetRowsParams, this.taskTemplateData, data.body.total, data.body.status);
        },
        (err) => { this.errorUtil.setErrorMessage(err); }
      );
  }

  /********************************** Set Grid Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  // ✅ CHANGED: .success({rowData, rowCount}) → successCallback()
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    if (this.taskTemplateData.length === 0) {
      this.gridApi.showNoRowsOverlay();
      this.notaskTemplate = false;
      this.notaskTemplateIcon = true;
    } else {
      this.notaskTemplate = true;
      this.notaskTemplateIcon = false;
      this.gridApi.hideOverlay();
      // ✅ CHANGED: successCallback replaces .success({rowData, rowCount})
      agGridGetRowsParams.successCallback(this.taskTemplateData, totalCount);
    }
  }

  /********************************** Request Params **************************/
  getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: "team.teamName", sort: "asc" };
      agGridRequest.sortModel.push(this.parameters);
    }
    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /********************************** Row Selection **************************/
  onSelectionChanged(event: any) {
    console.log(event);
    var index = _.findIndex(this.taskTriggers.tmplTasks, (row: any) => {
      return row.id == event.data.id;
    });
    if (event.node.__selected) {
      if (index <= -1) {
        var user = { id: event.data.id };
        console.log(event, "selected event printing...");
        if (this.isNewJOTemplate === true) {
          this.taskTriggers.tmplTasks.push(event.data);
        } else {
          this.taskTriggers.tmplTasks.push(user);
        }

        if (this.taskTriggers.tmplTasks.length == this.orderGridTotalLength) {
          // this.taskTriggers.tmplTasks.push(event.data);
          this.selectAllChecked = true;
          $("#checkboxCustella").removeClass("indeterminate");
        } else if (
          this.taskTriggers.tmplTasks.length < this.orderGridTotalLength
        ) {
          this.selectAllChecked = false;
          $("#checkboxCustella").addClass("indeterminate");
        }
      }
    } else {
      if (index > -1) {
        console.log(index, "-----");
        // this.selectAllChecked = false;
        //this.allCheckedDataLength = null;
        this.taskTriggers.tmplTasks.splice(index, 1);

        if (this.taskTriggers.tmplTasks.length <= 0) {
          this.selectAllChecked = false;
          $("#checkboxCustella").removeClass("indeterminate");
        } else if (
          this.taskTriggers.tmplTasks.length >= 1 &&
          this.taskTriggers.tmplTasks.length < this.orderGridTotalLength
        ) {
          this.selectAllChecked = false;
          $("#checkboxCustella").addClass("indeterminate");
        }
      }
    }
    console.log(this.taskTriggers.tmplTasks.length, "====");
    if (this.taskTriggers.tmplTasks.length == 0) {
      this.submitTouched = true;
    } else {
      this.submitTouched = false;
    }
  }

  onRowClicked(event: any) {
    console.log(event.node,"row clicked", event.data);
    if (!event.data.disabled) {
      event.node.setSelected(!event.node.isSelected());
    }
  }

  /********************************** Add Task **************************/
  addTask() {
    if (this.data.comingFrom == undefined) {
      this.addJoTaskTemplate();
    } else {
      this.addChecklistQuestionTaskTemplate();
    }
  }

  addJoTaskTemplate() {
    if (!this.taskTriggers.tmplTasks || this.taskTriggers.tmplTasks.length == 0) return false;
    var formData = _.cloneDeep(this.taskTriggers);
    this.submitTouched = true;

    if (!this.isNewJOTemplate) {
      this.tasksService.saveTaskToJO(formData).subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully, null, "success", 1000);
          this.modalRef.hide();
        } else {
          this.submitTouched = false;
          this.errorUtil.setErrorMessage(res.status, null, res.error.title, "error", 3000);
        }
      });
    } else {
      let payloadData: any[] = [];
      this.taskTriggers.tmplTasks.map((t: any, index: number) => {
        payloadData.push({
          id: t.id,
          taskOrder: index + 1,
          templateName: t.templateName,
          taskName: t.taskName,
          taskStatus: t.taskStatus,
          mandatory: t.mandatory,
          assignTo: null,
          assignToGroup: null,
        });
      });

      this.globalJobordersService
        .appenTasksToJOTemplate(payloadData, this.data.tmplJobOrderId)
        .subscribe((res: any) => {
          if (res.status == 201 || res.status == 200) {
            this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully, null, "success", 1000);
            this.modalRef.hide();
            this.bsModalServc.setDismissReason(JSON.stringify({ data: payloadData }));
          } else {
            this.submitTouched = false;
            this.errorUtil.setErrorMessage(res.status, null, res.error.title, "error", 3000);
          }
        });
    }
  }

  addChecklistQuestionTaskTemplate() {
    if (!this.taskTriggers.tmplTasks || this.taskTriggers.tmplTasks.length == 0) return false;
    let formData = _.cloneDeep(this.taskTriggers);
    if (this.data.skipTaskListIds && formData) {
      formData.tmplTasks = formData.tmplTasks.filter(
        (t: any) => !this.data.skipTaskListIds.includes(t.id)
      );
    }
    if (!formData.tmplTasks || formData.tmplTasks.length == 0) return false;
    this.submitTouched = true;

    this.checklistService.createAnswerByTask(formData).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status === 200 || res.status === 201) {
          this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully, null, "success", 3000);
          this.modalRef.hide();
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorUtil.setErrorMessage(error.status, null, error.error.title, "error", 3000);
      }
    );
  }

  /********************************** Search **************************/
  quickSearch() { this.onGridReady(this.gridParams); }

  resetSearch() {
    this.filter.teamId = null;
    this.filter.siteId = null;
    this.filter.projectId = null;
    this.quickSearch();
  }

  /********************************** Language **************************/
  getLanguageData() {
    this.spinner.show();
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.loadTable = 1;
          this.initializeColumns();
          this.spinner.hide();
        }
      })
    );
  }

  push(obs: any) { super.push(obs); }

  /********************************** Initialize Columns **************************/
  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate =
      "<div class='not-found'><span>" + this.translate?.general.messages.noRecordsFound + "</span> </div>";

    const newData = [
      {
        headerName: this.translate?.setup.modules.templates.fields.templateName.singular,
        field: "templateName",
        width: 150,
        headerTooltip: "#",
      },
      {
        headerName: this.translate?.task.fields.taskName.singular,
        field: "taskName",
        width: 170,
        headerTooltip: "#",
      },
      {
        headerName: this.translate?.setup.importExport.fields.select.singular,
        field: "",
        width: 80,
        headerTooltip: "#",
        checkboxSelection: true,
        cellStyle: (params: any) => {
          if (params.data) {
            return params.data.disabled ? { "pointer-events": "none", opacity: "0.4" } : "";
          }
        },
        cellRenderer: (params: any) => {
          if (params.data) {
            if (this.selectAllChecked || params.data.disabled) {
              params.node.setSelected(true);
            } else if (!this.selectAllChecked && this.formData.tasks.length >= 1) {
              for (var i = 0; i <= this.formData.tasks.length - 1; i++) {
                if (this.formData.tasks[i].id === params.data.id) {
                  params.node.setSelected(true);
                  return;
                } else {
                  params.node.setSelected(false);
                }
              }
            } else {
              params.node.setSelected(false);
            }
          }
        },
      },
    ];

    this.columnDefs = newData;
    if (this.gridApi) {
      // ✅ CHANGED: setColumnDefs() → setGridOption("columnDefs", ...)
      this.gridApi.setGridOption("columnDefs", this.columnDefs);
      setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 500);
    }
  }
}